export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14684.5c38afc4.jpg";